export default __webpack_public_path__ + "static/media/Sylvana_Q._Sinha_AHV_In_Moms_We_Trust.a696bab9.jpg";